// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"ad08b1fd","795":"2986f831"}[chunkId] + ".chunk.js";
};